<template>
  <v-menu offset-y :disabled="disabled">
    <template v-slot:activator="{ on }">
      <v-chip
        v-on="disabled ? {} : on"
        :style="getStatusColor(orderStatus)"
        class="text-capitalize"
        :class="disabled ? 'cursor-default opacity-60' : 'cursor-pointer'"
        label
        small
      >
        {{ statuses.find((status) => status.value === orderStatus)?.value }}
        <v-icon right small v-if="!disabled" :style="{ color: getStatusIconColor(orderStatus) }">
          mdi-chevron-down
        </v-icon>
      </v-chip>
    </template>
    <v-list
      style="
        max-height: 200px;
        overflow-y: auto;
        width: 250px;
        border-radius: 4px;
        text-align: center;
      "
    >
      <v-list-item
        v-for="status in statuses"
        :key="status.value"
        @click="handleStatusChange(status.value)"
      >
        <v-list-item-content :style="getStatusColor(status.value)">
          <span style="white-space: nowrap; font-size: 14px">{{ status.label }}</span>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { orderStatusColors } from '@/utils/workforce/statusColors'

export default {
  props: {
    orderStatus: String,
    statuses: Array,
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleStatusChange(status) {
      this.$emit('statusChange', status)
    },
    getStatusColor(status) {
      const colorInfo = orderStatusColors[status]
      return {
        color: colorInfo ? colorInfo.textColor : 'black',
        backgroundColor: colorInfo ? colorInfo.bgColor : 'white',
        height: '24px',
        borderRadius: '4px',
        padding: '0 8px',
        fontSize: '12px',
        boxShadow: 'none',
        border: '1px solid transparent',
        cursor: 'pointer'
      }
    },
    getStatusIconColor(status) {
      const colorInfo = orderStatusColors[status]
      return colorInfo ? colorInfo.textColor : 'black'
    }
  }
}
</script>
